import Vue from 'vue'
import Router from 'vue-router'

import { publicRoute, protectedRoute } from './config'

import SessionHelper from '@/helpers/SessionHelper'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router)
const routes = publicRoute.concat(protectedRoute)
const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: routes,
})
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start()

  // Si la sesión persistida ya expiró, limpiamos antes de evaluar permisos.
  if (SessionHelper.isExpired()) {
    SessionHelper.clear()
  }

  const { role } = SessionHelper

  if (
    ['TRA', 'MENSAJERO', 'ENT'].includes(role) &&
    ['/dashboard', '/logistica'].includes(to.path)
  ) {
    return next(
      role === 'TRA' ? '/logistica/transportista' : '/logistica/mensajeria'
    )
  }

  // Si la ruta no existe enviamos al 404 Page
  if (!to.matched.some(record => record)) {
    return next({
      path: '/404',
    })
  }

  if (typeof to.redirectedFrom !== 'undefined') {
    if (to.path === '/dashboard' && to.redirectedFrom === '/') {
      if (role === null) {
        location.href = '/home.html'
      }
    }
  }

  // Si la ruta existe y requiere autenticacion, validamos o envimos al login.
  const restricted = to.matched
    .slice()
    .reverse()
    .find(record => Array.isArray(record.meta.roles))
  if (restricted) {
    if (role === null) {
      return next({
        path: '/auth/login',
      })
    }

    const roles = restricted.meta.roles
    if (roles.includes(role)) {
      return next()
    } else {
      return next({
        path: '/403',
      })
    }
  } else {
    next() // si no requiere autenticacion pasamos.
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
